// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"f499ba90","501":"7ea2ad5e","513":"f7e6d224","706":"773da0a0","827":"46b85d50"}[chunkId] + ".chunk.js";
};